<template>
  <td
      v-if="showComponent"
      :title="qaAble ? showIfHasPermission?.toString() : null"
      v-show="!isHidden"
      :key="componentRefresh"
      :style="{'padding': padding, 'margin': margin, 'min-width': width}"
      :class="[showViewportClass, classes]"
      :colspan="colspan"
  >
    <slot></slot>
  </td>
</template>

<script>
import checkPermissions from '../../../../mixins/checkPermissions';
import showViewport from '../../../../mixins/showViewport'

export default {
  name: 'ks-list-table-column',
  mixins: [showViewport, checkPermissions],
  props: {
    headerIcon: {type: String, default: null}, // required if no headerLabel -- must be unique
    headerTitle: {type: String, default: null}, // not required
    headerLabel: {type: String, default: null}, // required if no headerIcon -- must be unique
    headerSortable: {type: Boolean, default: true},
    headerHiddenable: {type: Boolean, default: true},
    headerClickable: {type: Boolean, default: false},
    padding: {type: String, default: "3px"},
    margin: {type: String, default: "0"},
    width: {type: String, default: null},
    classes: {type: String, default: ""},
    dataSource: {type: String, default: null},
    colspan: {type: String, default: null}
  },
  computed: {
    data_provider_ref() {
      return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
    },
    dataProvider() {
      return this.$parent.dataProvider ? this.$parent.dataProvider : null;
    },
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    }
  },
  watch: {
    '$parent.columns': {
      handler(columns) {
        this.setIsHidden(columns);
      },
      deep: true
    }
  },
  methods: {
    setIsHidden(columns) {
      this.isHidden = false;
      for (let column in columns) {
        if (column === this.dataSource) {
          this.isHidden = columns[column].isHidden;
        }
      }
    }
  },
  mounted() {
    let found = this.$parent.headers.find(header => {
      if (header.label) {
        return header.label === this.headerLabel;
      } else if (header.icon) {
        return header.icon === this.headerIcon;
      }
    });
    if (!found && (this.headerLabel || this.headerIcon)) {
      this.$parent.headers.push({
        'label': this.headerLabel,
        'title': this.headerTitle,
        'icon': this.headerIcon,
        'sortable': this.headerSortable,
        'hiddenable': this.headerHiddenable,
        'dataSource': this.dataSource,
        'clickable': this.headerClickable,
        'showIfHasPermission': this.showIfHasPermission
      });
    }
    this.setIsHidden(this.$parent.columns);
  },
  data() {
    return {
      type: 'list',
      isHidden: false,
    }
  }
}
</script>
